import { Link, useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { groups } from '../lib/api'
import { Button } from '../components/ui/Button'
import { Card } from '../components/ui/Card'

/** Server-projected guardian observation never sends membership or presence writes. */
export function GroupObservationPage() {
  const { id } = useParams<{ id: string }>()
  const query = useQuery({ queryKey: ['community', 'group-observation', id], queryFn: () => groups.observeGroup(id!), enabled: !!id, retry: false })
  return <div className="animate-rise px-5 py-6 sm:px-10 sm:py-9">
    <Link to="/">Back to home</Link>
    {query.isLoading ? <p role="status" className="mt-5">Loading observation…</p> : query.isError || !query.data ? <div role="alert" className="mt-5"><h1 className="font-serif text-2xl">This group could not be observed</h1><p className="mt-2 text-sm">A guardian can observe a group where a managed profile is a member.</p><Button className="mt-3" variant="outline" onClick={() => void query.refetch()}>Retry observation</Button></div> : <>
      <h1 className="mt-4 font-serif text-[30px] text-ink">Observe {query.data.groupName}</h1>
      <p className="mt-3 text-sm leading-relaxed text-ink-muted">Read-only guardian view for {query.data.observedChildFirstName}. Opening this page does not join you as a player or add your presence.</p>
      <p className="mt-2 text-sm text-ink-muted">Other players retain the identity visibility supplied by the server.</p>
      <div className="mt-5 grid gap-3 sm:grid-cols-2">{query.data.members.map((member) => <Card key={member.personId}>
        <h2 className="break-words text-base font-semibold">{member.firstName || member.handle || 'A player'}</h2>
        {member.handleInGame && <p className="mt-2 break-all font-mono text-sm">{member.handleInGame}</p>}
        {member.likes && <p className="mt-2 text-sm text-ink-muted">Likes: {member.likes}</p>}
        {member.plays && <p className="text-sm text-ink-muted">Plays: {member.plays}</p>}
      </Card>)}</div>
    </>}
  </div>
}
